import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrow = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 24,
	viewBox: "0 0 20 24",
	stroke: "currentColor",
	fill: "transparent",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M2 10L10 2L18 10",
		strokeWidth: 4,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10 4L10 21.5",
		strokeWidth: 4,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgArrow;
